"use strict";
exports.__esModule = true;
exports.runAfterInteractions = void 0;
var react_native_1 = require("react-native");
function runAfterInteractions(cb) {
    return new Promise(function (resolve, reject) {
        react_native_1.InteractionManager.runAfterInteractions(function () {
            try {
                resolve(cb());
            }
            catch (e) {
                reject(e);
            }
        });
    });
}
exports.runAfterInteractions = runAfterInteractions;
